import { ChangeDetectionStrategy, Component, input } from '@angular/core';

type Variant = 'primary' | 'secondary' | 'danger';
type Type = 'button' | 'submit' | 'reset';

@Component({
  selector: 'app-button',
  imports: [],
  templateUrl: './button.html',
  styleUrl: './button.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Button {
  readonly variant = input<Variant>('secondary');
  readonly type = input<Type>('button');
  readonly disabled = input<boolean>(false);
  readonly loading = input<boolean>(false);
  readonly form = input<string>('');
}
